<template>
  <el-dialog  title="选择报警设备" :modal="false" :visible.sync="showBlock" :show-close="true"  width="800px" :before-close="closedBtn"  :close-on-click-modal="false">
    <div>
      <el-form
          ref="form"
          :model="params"
          label-width="120px"
          label-position="left"
        >
        <el-form-item label="报警设备关联" prop="name">
          <el-select style="width:100%" placeholder="请选择">
              <!-- <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option> -->
            </el-select>
        </el-form-item>
        <el-form-item label="位置区域" prop="name">
          <el-select style="width:100%" placeholder="请选择">
              <!-- <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option> -->
            </el-select>
        </el-form-item>
        <el-form-item label="设备类型" prop="name">
          <el-select style="width:100%" placeholder="请选择">
              <!-- <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option> -->
            </el-select>
        </el-form-item>
        <el-form-item label="序列号/IMEI" prop="name">
          <el-select style="width:100%" placeholder="请选择">
              <!-- <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option> -->
            </el-select>
        </el-form-item>
          <el-form-item label="报警名称" prop="type">
            <el-select style="width:100%" placeholder="请选择">
              <!-- <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="操作动作" prop="name">
            <el-select style="width:100%" placeholder="请选择">
              <!-- <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.label"
                :value="item.id">
              </el-option> -->
            </el-select>
          </el-form-item>
          <!--  -->
          <el-form-item label="报警延迟" prop="name">
            <el-input></el-input>
          </el-form-item>
        </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showBlock = false">取 消</el-button>
      <el-button type="primary" @click="closedBtn">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      showBlock: false,
    };
  },
  mounted(){
    
  },
  methods:{
    open(item){
      this.showBlock = true;
    },
    closedBtn(){
      this.showBlock = false;
    }
  }
}
</script>

<style lang="scss" scoped>
   ::v-deep .el-dialog__header{
    // width: 92%;
    height: 23px;
    background: #F8F9FA;
    box-shadow: 0px 1px 0px 0px rgb(237 238 240);
    border-radius: 12px 12px 0 0;
   }
   ::v-deep .el-dialog{
    border-radius: 12px;
   }

</style>